import React, { Component } from "react";
import { OwnerCommitteeStatus } from "../../ownercommitteeapi/entities";
import ListDataView from "../DataView/ListDataView";
import Strings from "@my-dld/assets/strings";
import { I8N, LocaleUtil } from "@eres/core";
import { DataTableLang } from "@my-dld/utils/DataTableUtils";
import {
	getOCReqCommitteeStatus,
	getOCReqDate,
	getOCReqNo,
	getOCReqPropertyInfo,
	getOCReqStatus
} from "@my-dld/screens/MyDLD/MyRequest/OwnerCommitteeRequests";

export interface OCReqProps {
	items: OwnerCommitteeStatus[];
}

class OCRequestsListView extends Component<OCReqProps> {
	componentDidMount(): void {
		this.configDataTable();
	}

	render() {
		const { items } = this.props;
		return <ListDataView
			items={ items }
			renderListHeader={ () => {
				return <RenderHeader/>;
			} }
			renderListItem={ ( item: OwnerCommitteeStatus ) => {
				return <RenderListItem
					key={ item.referenceId }
					item={ item }/>;
			} }/>;
	}

	private configDataTable = () => {
		try {
			window.$( "#ListView" ).DataTable( {
				//language: LocaleUtil.Select( DataTableLang ),
                language: { url: "https://cdn.datatables.net/plug-ins/1.10.20/i18n/" + (I8N.current == "ar" ? "Arabic.json" : "English.json"), lengthMenu: '_MENU_' },
                dom: "<'table-responsive'rt>" + "<'dt-cfooter'i<'dt-fpl'pl>>",
                pagingType: "simple_numbers",
				responsive: false,
				lengthChange: false,
				scrollX: true
			} );
		} catch ( e ) {
			console.warn( "Data table unavailable", e );
		}
	};
}

function RenderHeader() {
	return <tr>
		<th>{ Strings.request_number }</th>
		<th>{ Strings.date }</th>
		<th>{ Strings.property_information }</th>
		<th>{ Strings.status }</th>
		<th>{ Strings.committee_status }</th>
	</tr>;
}

function RenderListItem( props: { item: OwnerCommitteeStatus } ) {
	const { item } = props;
	return <tr>
		<td data-label={ Strings.request_number }>{ getOCReqNo( item ) }</td>
		<td data-label={ Strings.date }>{ getOCReqDate( item ) }</td>
		<td data-label={ Strings.property_information }>{ getOCReqPropertyInfo( item ) }</td>
		<td data-label={ Strings.status }>{ getOCReqStatus( item ) }</td>
		<td data-label={ Strings.committee_status }>{ getOCReqCommitteeStatus( item ) }</td>
	</tr>;
}

export default OCRequestsListView;
